module.exports = __webpack_public_path__ + "img/roadmap-cell-background-2.0e6db0ae.svg";